
import React, { useState, useEffect } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

  const imgurl = `${process.env.REACT_APP_URL}/image/products`

const CarouselSlide = ({ slides, autoSlide = false, autoSlideInterval = 3000 }) => {
  const [curr, setCurr] = useState(0)

  const prev = () => setCurr((curr) => (curr === 0 ? slides.length - 1 : curr - 1));

  const next = () => setCurr((curr) => (curr === slides.length - 1 ? 0 : curr + 1));


  useEffect(() => {
      if (!autoSlide) return
      const slideInterval = setInterval(next, autoSlideInterval)
      return () => clearInterval(slideInterval)
  }, [])

  return (
    <div className="flex flex-col mx-auto relative">

      <div className='flex overflow-hidden relative'>
        {slides.map((s,i) =>
        <div key={i} className="flex flex-col min-w-full gap-4 sm:flex-row justify-center transition-transform ease-out duration-1000" style={{ transform: `translateX(-${curr * 100}%)` }}>
          <img src={`${s.img}`} alt="" className="w-96 aspect-square mx-auto rounded-xl" />
          <div className="flex-col mx-auto px-4 border-t-2 sm:border-t-0 sm:border-l-2">
            <span className="text-2xl"> {s.name}</span>
            <p>{s.description}</p>
          </div>
        </div>
        )}
      </div>
      <div className="flex items-center justify-center p-4 gap-6">
        <button onClick={prev} className='p-1 rounded-full shadow bg-white/80 text-gray-800 opacity-15 hover:bg-white hover:opacity-100'>
          <ChevronLeftIcon className="h-6 w-6 text-gray-500" />
        </button>
        <div className='flex items-center justify-center gap-2'>
            {slides.map((s, i) => (
              <button key={i} 
                className={`transition-all text-xs w-4 h-4 text-center bg-slate-400 rounded-full hover:bg-opacity-90 ${curr === i ? "text-white bg-opacity-100" : " text-slate-500 bg-opacity-15"}`} 
                onClick={() => setCurr((curr) => (i))}
              >
              {i+1}
              </button>
            ))}
        </div>
        <button onClick={next} className='p-1 rounded-full shadow bg-white/80 text-gray-800 opacity-15 hover:bg-white hover:opacity-100'>
          <ChevronRightIcon className="h-6 w-6 text-gray-500" />
        </button>
      </div>
    </div>

  )
}

export default CarouselSlide